var map = {
	"./1-ilpakamaniPRENSA.jpg": "f883",
	"./2-ilpakamanicalletemuco.jpg": "2600",
	"./2-ilpakamaniotro.jpg": "81a5",
	"./5-ilpakamanioMASY.jpg": "5182",
	"./5-ilpakamaniotroMAS.jpg": "37eb",
	"./6-ilpakamanioMAS.jpg": "344f",
	"./6-ilpakamanioMASYmas.jpg": "6b6a",
	"./7-ilpakamanioMAS.jpg": "8af7",
	"./7-ilpakamanioMASY2.jpg": "3415",
	"./old_1.jpg": "282c",
	"./old_2.jpg": "c992",
	"./old_3.jpg": "f9be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "500f";